import { render, staticRenderFns } from "./NavigationLeft.vue?vue&type=template&id=deef49c0&scoped=true&"
import script from "./NavigationLeft.vue?vue&type=script&lang=js&"
export * from "./NavigationLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deef49c0",
  null
  
)

export default component.exports